import { render } from "./UsersPage.vue?vue&type=template&id=6a8986fe&ts=true"
import script from "./UsersPage.vue?vue&type=script&lang=ts"
export * from "./UsersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__